import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"


// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//socios

import FormularioAlta from "../components/FormularioAlta/FormularioAlta"
import Listado from "../components/FormularioAlta/Listado"
import Morosos from "../components/FormularioAlta/Morosos"
import Pagos from "../components/Pagos/Pagos"
import MetodosPago from "../components/MetodosPago/MetodosPago"
import DatosSocio from "pages/SociosList/DatosSocio"


//Tarifas
import Tarifas from "../components/Tarifas/Tarifas"
import Descuentos from "components/Tarifas/Descuentos"




//usuarios
import ListadoUser from "../components/Usuarios/Listado"



//Extra Pages
import PagesBlank from "../pages/Extra Pages/pages-blank";
import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  { path: "/pages-blank", component: <PagesBlank /> },



//Tarifas

  {path: "/tarifas", component: <Tarifas />},
  {path: "/descuentos", component: <Descuentos />},

  //Socios
  { path: "/alta", component: <FormularioAlta /> },
  { path: "/listado", component: <Listado /> },
  { path: "/morosos", component: <Morosos /> },
  {path: "/MetodosPago", component: <MetodosPago />},
  {path: "/pagos", component: <Pagos />},
  {path: "/datos-socio/:id", component: <DatosSocio />},

  //usuarios
  { path: "/listado-usuarios", component: <ListadoUser /> },


  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },

  
]

export { userRoutes, authRoutes }